import React from "react"
import { Block } from "baseui/block"
import AdSlotBlock from "./AdSlotBlock"

type WysiwygRendererProps = {
  content: string
  className?: string
  withAds?: boolean
}

const WysiwygRenderer = ({
  content,
  className = "",
  withAds = false,
}: WysiwygRendererProps) => {
  const iframeRegex = new RegExp(
    "(?:<iframe[^>]*)(?:(?:/>)|(?:>.*?</iframe>))",
    "ig"
  )

  const htmlContent = content.replace(
    iframeRegex,
    '<div class="iframe-wrapper">$&</div>'
  )

  return (
    <>
      <div
        className={`wysiwyg ${className}`}
        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
      />
      {withAds && (
        <Block
          display={"flex"}
          justifyContent={"center"}
          marginLeft={"auto"}
          marginRight={"auto"}
          marginTop={"30px"}
          width={"320px"}
        >
          <AdSlotBlock type={"rect"} />
        </Block>
      )}
    </>
  )
}

export default WysiwygRenderer
